import * as React from "react";

const SvgIcnMinus = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M17.1 12a.6.6 0 01-.601.6H7.501a.6.6 0 110-1.2h8.998a.6.6 0 01.601.6z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnMinus;
